import {
  ButtonDropdown,
  ButtonDropdownProps,
} from "@amzn/awsui-components-console";
import React from "react";

import { useChatHistory } from "@/contexts/ChatHistoryContext";
import useDeleteModal from "@/hooks/chat-actions/useDeleteModal";
import useRenameModal from "@/hooks/chat-actions/useRenameModal";
import { ChatHistoryItem } from "@/types/chat-history";

export interface ChatNavOptionsProps {
  chatItem: ChatHistoryItem;
}

const ChatNavOptions: React.FC<ChatNavOptionsProps> = ({
  chatItem: { id: chatId, title, isPinned },
}) => {
  const { updateChatPinned } = useChatHistory();
  const { toggle: toggleRename, ModalComponent: RenameModal } = useRenameModal({
    chatId,
    title,
    isPinned,
  });
  const { toggle: toggleDelete, ModalComponent: DeleteModal } = useDeleteModal({
    chatId,
    title,
  });

  const handleItemClick = ({
    detail: { id },
  }: CustomEvent<ButtonDropdownProps.ItemClickDetails>) => {
    switch (id) {
      case "unpin":
      case "pin":
        updateChatPinned(chatId, !isPinned);
        break;
      case "rename":
        toggleRename();
        break;
      case "delete":
        toggleDelete();
        break;
    }
  };

  return (
    <>
      <ButtonDropdown
        items={[
          {
            text: title,

            items: [
              isPinned
                ? { id: "unpin", text: "Unpin Chat" }
                : { id: "pin", text: "Pin Chat" },
              { id: "rename", text: "Rename Chat" },
              { id: "delete", text: "Delete Chat" },
            ],
          },
        ]}
        onItemClick={handleItemClick}
        ariaLabel="Control instance"
        variant="inline-icon"
        expandToViewport
      />
      {RenameModal()}
      {DeleteModal()}
    </>
  );
};

export default ChatNavOptions;
